import * as React from 'react';
import { idMatchesActiveItemId } from '../../Header,helpers';
import { NavigationItemModel } from '../../Header.types';
import DesktopNavigationDropdownLink from '../DesktopNavigationDropdownLink/DesktopNavigationDropdownLink';
import S from './TradeDropdown.styles';

export type TradeDropdownProps = {
  items: NavigationItemModel[];
  visible: boolean;
  translations: Record<string, string>;
};

const TradeDropdown: React.FC<TradeDropdownProps> = ({ items, visible, translations }) => {
  const [activeItemId, setActiveItemId] = React.useState<string | null>(null);

  const dropdownLevelTwo = items.map((item) => item.children).flat();

  const visibleColumnCount = dropdownLevelTwo.filter((x): x is NavigationItemModel => {
    return x !== undefined && idMatchesActiveItemId(x.id, activeItemId);
  }).length;

  React.useEffect(() => {
    if (visible) {
      return;
    }

    setActiveItemId(null);
  }, [visible]);

  return (
    <S.Container aria-current={visible}>
      <S.Column>
        {items &&
          items.map((item) => (
            <DesktopNavigationDropdownLink
              key={item.id}
              item={item}
              dropdownLevel="1"
              active={idMatchesActiveItemId(item.id, activeItemId)}
              onHover={(itemId) => setActiveItemId(itemId)}
              translations={translations}
            />
          ))}
      </S.Column>
      <S.Column>
        {dropdownLevelTwo.map((item) => {
          if (!item) {
            return null;
          }

          return (
            <li key={item.id}>
              <S.Column
                data-visible={idMatchesActiveItemId(item.id, activeItemId)}
                data-force-four-columns={visibleColumnCount <= 4}
                data-force-five-columns={visibleColumnCount <= 5}
                data-split-columns={item.children && item.children.length >= 22}
              >
                <DesktopNavigationDropdownLink
                  key={item.id}
                  item={item}
                  visible={idMatchesActiveItemId(item.id, activeItemId)}
                  dropdownLevel="2"
                  translations={translations}
                />
                {item.children &&
                  item.children.map((childItem) => (
                    <DesktopNavigationDropdownLink
                      key={childItem.id}
                      item={childItem}
                      visible={idMatchesActiveItemId(childItem.id, activeItemId)}
                      dropdownLevel="3"
                      translations={translations}
                    />
                  ))}
              </S.Column>
            </li>
          );
        })}
      </S.Column>
    </S.Container>
  );
};

export default TradeDropdown;
